// extracted by mini-css-extract-plugin
export default {"header":"smzBL","burger":"ZYIJK","logo":"NLnYE"};